import { format } from 'date-fns';

export const formatDateTime = (date: string | Date | undefined) => {
    if (!date) {
        return '-';
    }

    return format(new Date(date), "dd/MM/yyyy HH:mm:ss");
} 

export const formatDateNoTime = (date: string | Date | undefined) => {
    if (!date) {
        return '-';
    }

    return format(new Date(date), "dd/MM/yyyy");
} 